module.exports = __webpack_public_path__ + "img/process_02.8a0c7162.png";